/**
 * 模块 进入 事件 定义
 * @constructor
 */
export default function ModuleEventConfig() {

}
